module.exports = __webpack_public_path__ + "img/turn1east.d24afb6b.jpg";